<template>
  <div id="errore">
    <div style="padding:20px">
      <h2>Spiacenti. Si è verificato un errore durante l'elaborazione.</h2>
      <p
        style="border-style:solid;border-width:1px;padding:10px;margin-top:15px"
        v-if="errore != undefined && errore.trim() != ''"
      >
        <strong>Errore: </strong>
        <strong>
          <i>{{ errore }}</i>
        </strong>
      </p>
      <p>
        Nel caso tale errore dovesse ripetersi, Vi preghiamo di inviare un email a         <a
          v-bind:href="'mailto:' + $store.state.EmailFacileCheckIn"
        >{{ $store.state.EmailFacileCheckIn }}</a>.
      </p>

      <p>Ci scusiamo per il disagio.
      <br />Facile CheckIn</p>
    </div>

    <div style="padding:20px">
      <h2>Sorry. An error occurred during processing.</h2>

      <p
        style="border-style:solid;border-width:1px;padding:10px;margin-top:15px"
        v-if="errore != undefined && errore.trim() != ''"
      >
        <strong>Error: </strong>
        <strong>
          <i>{{ errore }}</i>
        </strong>
      </p>

      <p>
        If this error occurs again, please contact us on         <a
          v-bind:href="'mailto:' + $store.state.EmailFacileCheckIn"
        >{{ $store.state.EmailFacileCheckIn }}</a>.
.
      </p>

      <p>We apologize for the inconvenience.
      <br />Facile CheckIn</p>
    </div>

    <div style="padding:20px">
      <h2>Entschuldigung. Bei der Verarbeitung ist ein Fehler aufgetreten.</h2>

      <p
        style="border-style:solid;border-width:1px;padding:10px;margin-top:15px"
        v-if="errore != undefined && errore.trim() != ''"
      >
        <strong>Fehler: </strong>
        <strong>
          <i>{{ errore }}</i>
        </strong>
      </p>

      <p>
        Wenn dieser Fehler erneut auftritt, kontaktieren Sie uns bitte unter         <a
          v-bind:href="'mailto:' + $store.state.EmailFacileCheckIn"
        >{{ $store.state.EmailFacileCheckIn }}</a>.
.
      </p>
      <p>Wir entschuldigen uns für die Unannehmlichkeiten.

      <br />Facile CheckIn</p>
    </div>
    <br />
  </div>
</template>

<script>
// import store from "@/store/index";
// const axios = require("axios");

export default {
  name: "Errore",
  data() {
    return {};
  },
  props: {
    errore: String
  },
//   beforeRouteEnter(to, from, next) {
//     let ServerURL = store.state.ServerURL;

// console.log(to)
// console.log(from)

//     axios({
//       method: "get",
//       url:
//         ServerURL +
//         "CheckIn/RegistraErrore?errore=" +
//         to.params.errore +
//         "&source=" +
//         to.params.errore +
//         "&lineno=0" +
//         "&colno=0"
//     });

//     next();
//   }
};
</script>
